import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, filterVAutocomplete } from "@/js/forms.js";
import { listUserGroups, expeditionMethods, expeditionMethodList, pricePostingUsaProConstants } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import MultipleCountryStatesSelector from "@/components/shipping/MultipleCountryStatesSelector.vue";
export default {
  name: "ScheduledLogisticCostsModal",
  props: {
    listCountries: {
      type: Array,
      default: []
    },
    listStates: {
      type: Array,
      default: []
    },
    listCountriesArrival: {
      type: Array,
      default: []
    },
    listStatesArrival: {
      type: Array,
      default: []
    }
  },
  components: {
    MultipleCountryStatesSelector: MultipleCountryStatesSelector,
    Confirm: Confirm
  },
  data: function data(_this) {
    return {
      shown: false,
      isLoading: false,
      isAdding: false,
      isDeletingAll: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      openedPanels: [0],
      now: new Date(),
      minDate: moment().add(1, "days").toDate().formatForDatePickerDays(),
      scheduledModifications: [],
      modificationTypesEnum: [{
        id: 1,
        name: "Calculations",
        constant: "CALCULATIONS"
      }, {
        id: 2,
        name: "Definition",
        constant: "DEFINITION"
      }],
      form: {
        modificationType: null,
        scheduledApplicationDate: moment().add(1, "months").startOf("month").toDate().formatForDatePickerDays(),
        modificationPercentageEurPerBottle: null,
        modificationAddEurPerBottle: null,
        futureShippingPriceEurPerBottle: null,
        expeditionMethods: [],
        departures: [],
        exceptionDepartures: [],
        arrivals: [],
        exceptionArrivals: [],
        userGroup: null
      },
      managedExceptions: {
        warning: {
          conflict_date: "There is already a scheduled modification for this configuration."
        }
      },
      addDateMenu: null,
      futureHeaders: [{
        text: "Scheduled date",
        value: "scheduledApplicationDate",
        align: "left"
      }, {
        text: "Shipping type(s)",
        value: "expeditionMethods",
        align: "left"
      }, {
        text: "Arrival location(s)",
        value: "arrivalLocations",
        align: "left"
      }, {
        text: "Departure location(s)",
        value: "departureLocations",
        align: "left"
      }, {
        text: "User group",
        value: "userGroup",
        align: "left"
      }, {
        text: "Modifications",
        value: "modifications",
        align: "center"
      }, {
        text: "",
        value: "action",
        align: "right"
      }],
      previousHeaders: [{
        text: "Application date",
        value: "actualApplicationDate",
        align: "left"
      }, {
        text: "Shipping type(s)",
        value: "expeditionMethods",
        align: "left"
      }, {
        text: "Arrival location(s)",
        value: "arrivalLocations",
        align: "left"
      }, {
        text: "Departure location(s)",
        value: "departureLocations",
        align: "left"
      }, {
        text: "User group",
        value: "userGroup",
        align: "left"
      }, {
        text: "Modifications",
        value: "modifications",
        align: "center"
      }],
      expeditionMethodList: expeditionMethodList,
      listUserGroups: listUserGroups,
      rules: formRules,
      pricePostingUsaProConstants: pricePostingUsaProConstants
    };
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      var _this$form$arrivals, _this$form$departures;
      if (this.form.modificationType === this.modificationTypesEnum.find(function (x) {
        return x.constant === "CALCULATIONS";
      }).id) {
        if (+this.form.modificationPercentageEurPerBottle == 0 && +this.form.modificationAddEurPerBottle == 0) return true;
      } else if (this.form.modificationType === this.modificationTypesEnum.find(function (x) {
        return x.constant === "DEFINITION";
      }).id) {
        if (+this.form.futureShippingPriceEurPerBottle == 0) return true;
      }
      return ((_this$form$arrivals = this.form.arrivals) === null || _this$form$arrivals === void 0 ? void 0 : _this$form$arrivals.some(function (x) {
        return !x.countryId;
      })) || this.form.exceptionArrivals.some(function (x) {
        return !x.countryId;
      }) || ((_this$form$departures = this.form.departures) === null || _this$form$departures === void 0 ? void 0 : _this$form$departures.some(function (x) {
        return !x.countryId;
      })) || this.form.exceptionDepartures.some(function (x) {
        return !x.countryId;
      });
    },
    derivedExpeditionMethods: function derivedExpeditionMethods() {
      return expeditionMethodList.filter(function (x) {
        return x !== expeditionMethods.CELLAR_STORAGE;
      });
    },
    derivedUserGroups: function derivedUserGroups() {
      return listUserGroups.filter(function (x) {
        return ["USER", "HORECA"].includes(x.id);
      });
    },
    derivedCountries: function derivedCountries() {
      var _this2 = this;
      return this.listCountries.map(function (country) {
        return _objectSpread(_objectSpread({}, country), {}, {
          states: _this2.listStates.filter(function (state) {
            return state.id_country === country.id_country;
          })
        });
      });
    },
    derivedCountriesArrival: function derivedCountriesArrival() {
      var _this3 = this;
      return this.listCountriesArrival.map(function (country) {
        return _objectSpread(_objectSpread({}, country), {}, {
          states: _this3.listStates.filter(function (state) {
            return state.id_country === country.id_country;
          })
        });
      });
    },
    futureScheduledModifications: function futureScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return !x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(a.scheduledApplicationDate) - new Date(b.scheduledApplicationDate);
      });
    },
    previousScheduledModifications: function previousScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(a.scheduledApplicationDate) - new Date(b.scheduledApplicationDate);
      });
    },
    isHorecaIncludedInUserGroup: function isHorecaIncludedInUserGroup() {
      if (!this.form.userGroup) return true;
      return this.form.userGroup === listUserGroups.find(function (x) {
        return x.id === "HORECA";
      }).id;
    },
    containsForbiddenStates: function containsForbiddenStates() {
      var _this$listCountries$f,
        _this4 = this;
      if (this.form.arrivals.some(function (x) {
        var _x$stateIds;
        return ((_x$stateIds = x.stateIds) === null || _x$stateIds === void 0 ? void 0 : _x$stateIds.length) > 0;
      })) return false;
      if (this.form.exceptionArrivals.some(function (x) {
        var _x$stateIds2;
        return ((_x$stateIds2 = x.stateIds) === null || _x$stateIds2 === void 0 ? void 0 : _x$stateIds2.length) > 0;
      })) return false;
      var usCountryId = (_this$listCountries$f = this.listCountries.find(function (x) {
        return x.iso_2 === "US";
      })) === null || _this$listCountries$f === void 0 ? void 0 : _this$listCountries$f.id_country;
      var forbiddenStateIds = this.listStates.filter(function (x) {
        return _this4.pricePostingUsaProConstants.some(function (state) {
          return state.iso2 === x.iso_state;
        });
      }).map(function (x) {
        return x.id_state;
      });
      var hasForbiddenArrivals = this.form.arrivals.some(function (x) {
        return x.countryId === usCountryId && forbiddenStateIds.includes(x.stateId);
      });
      var hasForbiddenExceptionArrivals = this.form.exceptionArrivals.some(function (x) {
        return x.countryId === usCountryId && forbiddenStateIds.includes(x.stateId);
      });
      return hasForbiddenArrivals || hasForbiddenExceptionArrivals;
    }
  },
  created: function created() {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this5.initFormValues) {
              _this5.form = _objectSpread(_objectSpread({}, _this5.form), _this5.initFormValues);
            } else {
              _this5.form.modificationType = _this5.modificationTypesEnum.find(function (x) {
                return x.constant === "CALCULATIONS";
              }).id;
            }
            _context.next = 3;
            return _this5.getScheduledModifications();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    changeModificationType: function changeModificationType() {
      if (this.form.modificationType === this.modificationTypesEnum.find(function (x) {
        return x.constant === "DEFINITION";
      })) {
        this.form.modificationPercentageEurPerBottle = null;
        this.form.modificationAddEurPerBottle = null;
      } else if (this.form.modificationType === this.modificationTypesEnum.find(function (x) {
        return x.constant === "CALCULATIONS";
      })) {
        this.form.futureShippingPriceEurPerBottle = null;
      }
    },
    getScheduledModifications: function getScheduledModifications() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this6.isLoading = true;
              _this = _this6;
              _context2.next = 4;
              return request("/v1/scheduled-logistic-costs-modifications/", "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load scheduled modifications.", {
                  type: "error"
                });
                _this6.isLoading = false;
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this6.scheduledModifications = _toConsumableArray(response.data.value);
              _this6.isLoading = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this7.isAdding = true;
              _this = _this7;
              _context3.next = 4;
              return _this7.addScheduledModification().catch(function (e) {
                _this.isAdding = false;
                throw e;
              });
            case 4:
              _context3.next = 6;
              return _this7.getScheduledModifications();
            case 6:
              _this7.isAdding = false;
              _this7.$toasted.show("Scheduled modification added.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    addScheduledModification: function addScheduledModification() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = _objectSpread({}, _this8.form);
              _this = _this8;
              _context4.next = 4;
              return request("/v1/scheduled-logistic-costs-modifications", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to add the scheduled modification.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    confirmCancelScheduledModification: function confirmCancelScheduledModification(item) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this9.$refs.confirm.open("Delete", "Are you sure you want to cancel this scheduled modification ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(confirm) {
                  var _this;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!confirm) {
                          _context5.next = 6;
                          break;
                        }
                        _this = _this9;
                        _context5.next = 4;
                        return _this9.cancelScheduledModification(item).catch(function (e) {
                          var errorData = getErrorData(e, _this.managedExceptions, "Unable to cancel scheduled modification.");
                          _this.$toasted.show(errorData.message, {
                            type: errorData.type
                          });
                        });
                      case 4:
                        _this9.getScheduledModifications();
                        _this9.$toasted.show("Scheduled modification cancelled.", {
                          type: "success"
                        });
                      case 6:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    cancelScheduledModification: function cancelScheduledModification(item) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              item.isDeleting = true;
              _context7.next = 3;
              return request("/v1/scheduled-logistic-costs-modifications/" + item.id, "delete", null, true, "api").catch(function (e) {
                item.isDeleting = false;
                throw e;
              });
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    confirmCancelAllFutureModifications: function confirmCancelAllFutureModifications() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.$refs.confirm.open("Delete", "Are you sure you want to cancel all scheduled modifications ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(confirm) {
                  var nbErrors, promises;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!confirm) {
                          _context8.next = 7;
                          break;
                        }
                        _this10.isDeletingAll = true;
                        nbErrors = 0;
                        promises = _this10.futureScheduledModifications.map(function (item) {
                          return _this10.cancelScheduledModification(item).catch(function () {
                            nbErrors++;
                          });
                        });
                        _context8.next = 6;
                        return Promise.all(promises);
                      case 6:
                        if (nbErrors == _this10.futureScheduledModifications.length) {
                          _this10.$toasted.show("Unable to cancel any of scheduled modification(s).", {
                            type: "error"
                          });
                        } else if (nbErrors > 0) {
                          _this10.$toasted.show("Unable to cancel ".concat(nbErrors, " scheduled modification(s)."), {
                            type: "warning"
                          });
                          _this10.getScheduledModifications();
                        } else {
                          _this10.getScheduledModifications();
                          _this10.$toasted.show("Scheduled modification cancelled.", {
                            type: "success"
                          });
                        }
                      case 7:
                        _this10.isDeletingAll = false;
                      case 8:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    mapLocations: function mapLocations(items) {
      if (items.some(function (x) {
        return x.stateIds.length > 0;
      })) {
        var finalItems = [];
        items.forEach(function (item) {
          if (item.stateIds.length > 0) {
            item.stateIds.forEach(function (stateId) {
              var newItem = {
                countryId: item.countryId,
                stateId: stateId
              };
              finalItems.push(newItem);
            });
          } else {
            finalItems.push(item);
          }
        });
        return [].concat(finalItems);
      } else {
        return _toConsumableArray(items);
      }
    },
    changeArrivals: function changeArrivals(items) {
      this.form.arrivals = this.mapLocations(items);
    },
    changeExceptionArrivals: function changeExceptionArrivals(items) {
      this.form.exceptionArrivals = this.mapLocations(items);
    },
    changeDepartures: function changeDepartures(items) {
      this.form.departures = this.mapLocations(items);
    },
    changeExceptionDepartures: function changeExceptionDepartures(items) {
      this.form.exceptionDepartures = this.mapLocations(items);
    },
    filterVAutocomplete: filterVAutocomplete
  }
};